import React from 'react';
import CompiledModalSpinner from './modalSpinner-compiled';

const ModalSpinner: typeof CompiledModalSpinner = (props) => <CompiledModalSpinner {...props} />;

export default ModalSpinner;
